// By A. Manso fit-measurements anchor
(() => {
  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();

  const locateMeasurements = () => {
    const candidates = document.querySelectorAll('main h2, main h3, main h4, main p, main strong, main b');
    for (const element of candidates) {
      const text = normalize(element.textContent);
      if (text === 'MEASUREMENTS' || text === 'FIT & MEASUREMENTS' || text === 'FIT AND MEASUREMENTS') {
        return element.closest('h2, h3, h4, p') || element;
      }
    }
    return null;
  };

  const connect = () => {
    const target = locateMeasurements();
    const links = document.querySelectorAll('[data-amanso-fit-link]');
    if (!links.length) return;

    if (target) {
      target.id = 'amanso-fit-measurements';
      target.style.scrollMarginTop = '7rem';
      // AMANSO_HASH_SCROLL
      if (window.location.hash === '#amanso-fit-measurements') {
        window.setTimeout(() => target.scrollIntoView({ behavior: 'auto', block: 'start' }), 120);
      }
      links.forEach((link) => {
        link.removeAttribute('aria-disabled');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        }, { once: true });
      });
    } else {
      links.forEach((link) => {
        link.textContent = 'FIT DETAILS IN PRODUCT DESCRIPTION';
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
